import { FunctionComponent, memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, useNewsFeed } from '../../../shared';
import { MyTopicsContent } from '../../MyTopics';

interface NewsFeedMyTopicsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const NewsFeedMyTopicsModal: FunctionComponent<NewsFeedMyTopicsModalProps> = memo(
  ({ isOpen, onClose }) => {
    const { t } = useTranslation();

    const { getNewsFeedItems, subTabStoryId } = useNewsFeed();

    const body = useMemo(() => <MyTopicsContent isModal />, []);

    const closeHandler = useCallback(() => {
      onClose();

      if (!subTabStoryId) {
        getNewsFeedItems();
      }
    }, [getNewsFeedItems, onClose, subTabStoryId]);

    return (
      <Modal
        isOpen={isOpen}
        onClose={closeHandler}
        body={body}
        ariaLabel={t('myTopics.title')}
        alignTop
      />
    );
  }
);
